import { render, staticRenderFns } from "./AwardCertificate.vue?vue&type=template&id=65c45e2a&scoped=true&"
import script from "./AwardCertificate.vue?vue&type=script&lang=js&"
export * from "./AwardCertificate.vue?vue&type=script&lang=js&"
import style0 from "./AwardCertificate.vue?vue&type=style&index=0&id=65c45e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c45e2a",
  null
  
)

export default component.exports